module.exports = __webpack_public_path__ + "static/img/set.39c17cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/set.png
// module id = AkZK
// module chunks = 1